function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';
import { Flex } from '@creditas-ui/layout';
import { useForkRef } from '@creditas-ui/utilities';
import { Erase, EyeHidden, EyeVisible, Loading } from '../Icons';
import { InputField, InputMessage, InputButton } from './InputOpened.style';
import { useInputOpened, Types } from './useInputOpened';
var InputOpened = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var error = _ref.error,
      disabled = _ref.disabled,
      helperText = _ref.helperText,
      placeholder = _ref.placeholder,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? Types.TEXT : _ref$type,
      loading = _ref.loading,
      cleanable = _ref.cleanable,
      className = _ref.className,
      value = _ref.value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["error", "disabled", "helperText", "placeholder", "type", "loading", "cleanable", "className", "value", "onChange"]);

  var _useInputOpened = useInputOpened({
    value: value,
    type: type,
    loading: loading,
    cleanable: cleanable,
    onChange: onChange
  }),
      showEyeButton = _useInputOpened.showEyeButton,
      handleOnChange = _useInputOpened.handleOnChange,
      handleEyeButton = _useInputOpened.handleEyeButton,
      handleEraseButton = _useInputOpened.handleEraseButton,
      showEraseButton = _useInputOpened.showEraseButton,
      text = _useInputOpened.text,
      currentType = _useInputOpened.currentType,
      inputRef = _useInputOpened.inputRef;

  var handleRefs = useForkRef(ref, inputRef);
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "flex-start",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(InputField, _extends({}, props, {
    placeholder: placeholder,
    ref: handleRefs,
    type: currentType,
    onChange: handleOnChange,
    value: text,
    disabled: disabled || loading,
    className: className
  })), showEraseButton && /*#__PURE__*/React.createElement(InputButton, {
    type: "button",
    "data-testid": "cleanableButton",
    onClick: handleEraseButton
  }, /*#__PURE__*/React.createElement(Erase, null)), showEyeButton() && /*#__PURE__*/React.createElement(InputButton, {
    type: "button",
    "data-testid": "eyeButton",
    onClick: handleEyeButton
  }, currentType === Types.TEXT ? /*#__PURE__*/React.createElement(EyeHidden, null) : /*#__PURE__*/React.createElement(EyeVisible, null)), loading && /*#__PURE__*/React.createElement(Loading, null)), helperText && !error && /*#__PURE__*/React.createElement(InputMessage, {
    padding: 0
  }, helperText), error && !disabled && /*#__PURE__*/React.createElement(InputMessage, {
    error: true
  }, error));
});
export { InputOpened };